import React, { useEffect, useState } from 'react';
import DataTable from '../../components/DataTablePtBr';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import Header from '../../components/Header';
import { showSuccess, showError, showConfirmation } from '../../services/alert';

const UsuarioList = () => {
  const [usuarios, setUsuarios] = useState([]);
  const navigate = useNavigate();

  const fetchUsuarios = async () => {
    try {
      const response = await api.get('/usuario');
      setUsuarios(response.data);
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
    }
  };

  useEffect(() => {
    fetchUsuarios();
  }, []);

  const handleDelete = async (id) => {
    const confirmed = await showConfirmation({
      title: 'Tem certeza?',
      text: `Você quer realmente remover o usuário?`,
      confirmText: 'Sim, deletar!',
      cancelText: 'Cancelar'
    });
    
    if (confirmed) {
      try {
        const response = await api.delete(`/usuario/${id}`);
        const message = response.data.message || 'Usuário removido com sucesso.';

        showSuccess(message);

        fetchUsuarios();
      } catch (error) {
        let errorMessage = "";

        if (error.response)
          errorMessage = error.response.data.message;
        else if (error.request)
          errorMessage = "Sem resposta do servidor.";
        else
          errorMessage = "Erro desconhecido: " + error.message;

        showError(errorMessage || 'Erro inesperado.');
      }
    }
  };

  const columns = [
    {
      name: 'Nome',
      selector: row => row.nome,
      sortable: true,
    },
    {
      name: 'Email',
      selector: row => row.email,
      sortable: true,
    },
    {
      name: 'Ações',
      cell: row => (
        <div className="d-flex gap-2">
          <button className="btn btn-outline-success btn-sm d-flex align-items-center gap-1" onClick={() => navigate(`/usuarios/edit/${row.id}`)}>
            <i className="bi bi-pencil-square"></i>
            <span>Editar</span>
          </button>
          <button className="btn btn-outline-danger btn-sm d-flex align-items-center gap-1" onClick={() => handleDelete(row.id)}>
            <i className="bi bi-trash"></i>
            <span>Excluir</span>
          </button>
        </div>
      )
    }
  ];

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-light btn-sm d-flex align-items-center gap-1"
              onClick={() => navigate('/menu')}
            >
              <i className="bi bi-arrow-left text-success"></i>
              <span className="text-success fw-semibold">Voltar</span>
            </button>
            <div>
              <h5 className="mb-0">Usuários</h5>
              <small className="text-white-50">Lista de usuários cadastrados</small>
            </div>
          </div>
          <button
            className="btn btn-light text-success fw-bold d-flex align-items-center gap-1"
            onClick={() => navigate('/usuarios/create')}
          >
            <i className="bi bi-plus-circle"></i>
            <span>Novo</span>
          </button>
        </div>
        <div className="card-body">
          <DataTable
            columns={columns}
            data={usuarios}
            pagination
            responsive
            highlightOnHover
            striped
            noDataComponent={<div className="text-muted">Nenhum usuário encontrado.</div>}
          />
        </div>
      </div>
    </div>
  );
};

export default UsuarioList;